import React from "react";
import { Link } from "@mui/material";
import Thumbnail from "./Thumbnail";
import FilePreview from "./FilePreview";

const TemporaryThumbnail = ({ file, url }) => {
    const [loadPreview, setLoadPreview] = React.useState(false);
    const isImage = file.type?.startsWith("image/");
    const isVideo = file.type?.startsWith("video/");

    return (
        <>
            <Link
                href="#"
                underline="none"
                title={file.name}
                sx={{ color: "#AF3241" }}
                onClick={(e) => {
                    e.preventDefault();
                    setLoadPreview(true);
                }}
            >
                <Thumbnail visualName={file.name} url={url} type={isImage ? "image" : "video"} />
            </Link>
            {/* ------ load picture ------ */}
            {loadPreview === true && (
                <FilePreview
                    open={loadPreview}
                    onClose={() => {
                        setLoadPreview(false);
                    }}
                    size={"md"}
                    url={url}
                    fileName={file.name}
                    type={isImage ? "image" : "video"}
                    closeModal={() => {
                        setLoadPreview(false);
                    }}
                />
            )}
        </>
    );
};

export default TemporaryThumbnail;
